import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setSideMenuSelectedItem, setToolbarTitle } from "../../redux/actions";
import logoVector from "../../resources/image/id_dashboard_welcome.webp";
import Linkages from "./linkage/linkage"
import Loading from "../util/page-loading"

class Dashboard extends Component {
  state = {
    pageTitle: "داشبورد",
    pageTag: "dashboard",
  };

  componentDidMount() {
    this.props.setSideMenuSelectedItem(this.state.pageTag);
    this.props.setToolbarTitle(this.state.pageTitle);
    document.title = this.state.pageTitle;
  }

  render() {
    var profile = this.props.profile
    var permissions = this.props.profile.clientPermissions

    return (
      <div className="fragment text-center">
       
        <div className="app-card mx-auto">
          <img
            className="col-12 col-sm-10 col-md-7 col-lg-6 col-xl-4"
            src={logoVector}
            alt=""
          />
          <div style={{fontSize: 18, color: "black"}}>به کنسول ویپاد خوش آمدید.</div>
          <div style={{fontSize: 14, color: "dimgray", marginTop: 16, marginBottom: 32}}>امکانات کنسول از طریق منوی اصلی در گوشه بالا سمت راست کنسول همواره در دسترس شماست.</div>
        </div>
        {
          (profile.username === undefined || profile.username === null) && <Loading/>
        }

        {permissions !== undefined && permissions["client_linkages"] &&
           <Linkages/>
        }
      </div>
    );
  }

  /****
  ** NETWORK
  *****/

}

//// REDUX STUFF
function mapStateToProps(state) {
  return {
    login: state.login,
    profile: state.profile.profile,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ setSideMenuSelectedItem: setSideMenuSelectedItem, setToolbarTitle: setToolbarTitle }, dispatch);
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Dashboard);
